import type { LandingPageContent } from "../types/content.types";

export const mockContent: LandingPageContent = {
  heroSection: {
    heading: "Master Your Future with Expert Online Tutoring",
    subheading:
      "Cambridge & Edexcel IGCSE and AS Level courses taught by qualified educators. Study anywhere, anytime, at your own pace.",
    youtubeId: "pN8ZWr0giaY",
    videoPoster:
      "https://img.youtube.com/vi/pN8ZWr0giaY/hqdefault.jpg",
    ctaText: "Start Learning Today",
  },
  comboDealsSection: {
    heading: "Choose Your Perfect Learning Package",
    combos: [
      {
        title: "IGCSE\nStandard Service",
        price: "R1,500/month for 6 subjects",
        image: "/images/bundle/GCSE-student.jpg",
        features: [
          "Comprehensive course materials",
          "Computer-assessed content",
          "Self-assessment memos",
          "Study at your own pace",
        ],
      },
      {
        title: "IGCSE\nPremium Service",
        price: "R2,500/month for 6 subjects",
        image: "/images/bundle/student-laptop-hero.jpg",
        features: [
          "Everything in Standard +",
          "Expert assessment & feedback",
          "Mock examinations",
          "Progress tracking",
          "Personalized support",
        ],
      },
      {
        title: "AS Level\nStandard Service",
        price: "R2,200/month for 5 subjects",
        image: "/images/bundle/AS-Student.jpg",
        features: [
          "Advanced course materials",
          "Computer-assessed content",
          "Self-assessment memos",
          "Flexible learning schedule",
        ],
      },
      {
        title: "AS Level\nPremium Service",
        price: "R3,200/month for 5 subjects",
        image: "/images/bundle/Bookshelf-and-student.jpg",
        features: [
          "Everything in Standard +",
          "Expert tutor support",
          "Full mock exam series",
          "Detailed progress reports",
          "One-on-one consultation",
        ],
      },
    ],
    ctaText: "Request a Personalized Quote",
  },
  hook2Section: {
    heading: "Explore Our Comprehensive Curriculum",
    subheading: "From Sciences to Humanities - We've Got You Covered",
    productImages: [
      "/images/subjects/GCSE Biology.jpeg",
      "/images/subjects/GCSE Math.jpg",
      "/images/subjects/GCSE Chemistry.jpeg",
      "/images/subjects/GCSE Physics.jpeg",
      "/images/subjects/GCSE English.jpeg",
      "/images/subjects/GCSE Geography Cambridge.jpeg",
      "/images/subjects/GCSE Business.jpg",
    ],
    ctaText: "Explore All Subjects",
  },
  manufacturingSection: {
    heading: "Real Results from Real Students",
    summary:
      "Our students consistently achieve outstanding results, with many going on to top universities around the world. Join a community of successful learners who've transformed their academic future with Guerilla Teaching.",
    fullText:
      "Our students consistently achieve outstanding results across all subjects and qualification levels. With expert tutors, proven curriculum, and personalized support, we've helped hundreds of students achieve their academic dreams.\n\nFrom securing A* grades to gaining admission to prestigious universities like Oxford, Cambridge, UCT, and Stellenbosch, our students' success stories speak for themselves. Our comprehensive approach combines rigorous academics with flexible, student-centered learning that adapts to individual needs and learning styles.",
    image: "/images/bundle/GCSE-student.jpg",
  },
  ourTeamSection: {
    heading: "Why Choose Guerilla Teaching?",
    summary:
      "We combine expert knowledge, proven results, and flexible learning to deliver an unmatched online education experience. Our qualified educators and comprehensive curriculum ensure you're fully prepared for exam success.",
    fullText:
      "At Guerilla Teaching, we're passionate about education and committed to your success. Our team of Cambridge and Edexcel-qualified educators brings years of teaching experience and deep subject expertise to every lesson.\n\nOur curriculum is meticulously aligned with international exam boards and regularly updated to reflect the latest specifications. We believe in flexible, student-centered learning that fits your schedule and learning style. Whether you're aiming for university admission or simply want to excel in your studies, we provide the support, resources, and expertise you need to succeed.",
    images: [
      "/images/bundle/student-laptop-hero.jpg",
      "/images/bundle/Bookshelf-and-student.jpg",
    ],
  },
  whatsapp: {
    phoneNumber: "27823319326",
    message:
      "Hi, I'm interested in learning more about Guerilla Teaching's IGCSE and AS Level courses",
  },
};
